import React from 'react';
import { bool, node, func, string } from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import cx from 'classnames';
import s from './PortalDialog.css';

import getMuiTheme from "material-ui/styles/getMuiTheme";
import portalTheme from "../../themes/portalTheme";


const PortalDialog = ({
  cancelLabel, cancelCallback, closeCallback, content, error,
  id, modal, okOnly, okLabel, okCallback, open, title,
}) => {

  const cancelButton =
    <FlatButton
      className={s.btn}
      id={`${id}__cancel_button`}
      keyboardFocused={true}
      label={cancelLabel || 'Cancel'}
      name="cancelButton"
      onClick={event => {
        if (cancelCallback) cancelCallback(event)
      }}
      rippleColor="transparent" // I could not find a better way to "disable" the ripple. As of version 0.19.0, disableTouchRipple would not remove it.
    />;

  const focusedOkButton =
    <FlatButton
      className={cx(s.btn, s.primaryBtn)}
      id={`${id}__ok_button`}
      keyboardFocused={true}
      label={okLabel || 'Ok'}
      name="okButton"
      onClick={event => {
        if (okCallback) okCallback(event)
      }}
      primary={true}
      rippleColor="transparent" // I could not find a better way to "disable" the ripple. As of version 0.19.0, disableTouchRipple would not remove it.
    />;

  const okButton =
    <FlatButton
      className={cx(s.btn, s.primaryBtn)}
      id={`${id}__ok_button`}
      label={okLabel || 'Ok'}
      name="okButton"
      onClick={event => {
        if (okCallback) okCallback(event)
      }}
      primary={true}
      rippleColor="transparent" // I could not find a better way to "disable" the ripple. As of version 0.19.0, disableTouchRipple would not remove it.
    />;

  // If the dialog is okOnly, then the ok button should be focused by default.
  // If the cancel and ok buttons are present, then the cancel button should be focused by default.
  const actions = okOnly ? focusedOkButton : [cancelButton, okButton];

  return (
    <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
      <Dialog
        id={id}
        actions={actions}
        actionsContainerClassName={s.dialogActionsRow}
        className={cx(s.dialog, { [`${s.singleButtonDialog}`]: okOnly, [`${s.errorDialog}`]: error })}
        contentClassName={s.content}
        children={content}
        modal={modal}
        onRequestClose={event => {
          if (closeCallback) closeCallback(event)
        }}
        open={open}
        title={title}
        titleClassName={s.title}
      />
    </MuiThemeProvider>
  );
};

PortalDialog.propTypes = {
  cancelLabel: node,
  cancelCallback: func,
  closeCallback: func,
  content: node,
  error: bool,
  id: string.isRequired,
  modal: bool,
  okOnly: bool,
  okLabel: node,
  okCallback: func,
  open: bool.isRequired,
  title: node,
};

export default PortalDialog;



// WEBPACK FOOTER //
// ./src/components/PortalDialog/PortalDialog.js